import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import configureStore from "./config/store";
import '../../node_modules/react-table/react-table.css';
import '../../node_modules/rodal/lib/rodal.css';
import "./sass/app.scss";
import registerServiceWorker from "./registerServiceWorker";
import App from "./App";
var conFStore = configureStore();
export var store = conFStore.store;
export var history = conFStore.history;
ReactDOM.render(React.createElement(Provider, { store: store },
    React.createElement(ConnectedRouter, { history: history },
        React.createElement(App, null))), document.getElementById("root"));
registerServiceWorker();



//////////////////
// WEBPACK FOOTER
// ./src/index.tsx
// module id = 219
// module chunks = 0